import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
} from '@angular/core';

import { OverviewSubjectNamePipe } from '../overview-subject-name.pipe';
import {
  ProgressBarComponent,
  SkeletonTextComponent,
  SubjectIconComponent,
} from '@lyceo/shared/ui';
import { SubjectIconShape } from '@lyceo/shared/util-models';

@Component({
  selector: 'lyceo-book-header',
  templateUrl: './book-header.component.html',
  styleUrls: ['./book-header.component.scss'],
  imports: [
    OverviewSubjectNamePipe,
    SubjectIconComponent,
    SkeletonTextComponent,
    ProgressBarComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookHeaderComponent {
  public readonly loading: InputSignal<boolean> = input<boolean>(false);
  public readonly showProgress: InputSignal<boolean | null> = input<
    boolean | null
  >(false);
  public subjectIconShape: SubjectIconShape = SubjectIconShape.ROUND;

  public readonly subjectName: InputSignal<string | undefined> = input<
    string | undefined
  >();
  public readonly bookName: InputSignal<string | undefined> = input<
    string | undefined
  >();
  public readonly completedChapters: InputSignal<number | undefined> = input<
    number | undefined
  >();
  public readonly totalChapters: InputSignal<number | undefined> = input<
    number | undefined
  >();
}
